<template>
  <div class="section" :class="main_color">
    <div class="page-content">
      <div class="part">
        <div class="lexique">
          <div class="titre-1">
            Synth&egrave;se et positionnement locatif du projet
          </div>
          <div class="source">Source : ADEQUATION</div>
          <div class="titre-2">Positionnement locatif et prix de vente</div>
          <div class="lex-content">
            <p>
              Les loyers indiqu&eacute;s concernent le march&eacute; libre. Ces
              loyers libres sont ceux qu'ADEQUATION estime praticables lors de
              la livraison des logements. Ils prennent notamment en compte les
              &eacute;l&eacute;ments suivants :
            </p>
            <ul>
              <li>
                L'ensemble des donn&eacute;es &eacute;tudi&eacute;es dans la
                fiche
              </li>
              <li>
                Les objectifs de CDC Habitat en termes de mise en location (50%
                &agrave; la livraison des logements)
              </li>
              <li>
                Le volume de logements du projet plac&eacute;s sur le
                march&eacute; locatif
              </li>
              <li>Les surfaces habitables des logements</li>
            </ul>
            <p>
              Les loyers sont indiqu&eacute;s hors charges (HC).<br />Pour le
              collectif, le loyer est indiqu&eacute; hors stationnement (hors
              stat.). Pour l&rsquo;individuel, le loyer est indiqu&eacute; avec
              stationnement (avec stat.).
            </p>
            <p>
              Pour le collectif le prix est indiqué hors stationnement. Pour l'individuel, le prix est indiqué avec stationnement.
            </p>
            <p>
              Les prix de vente du positionnement final de l'opération sont à considérer comme des références admissibles en neuf pour le projet, sur des produits standards (c'est-à-dire sans tenir compte compte d'un éventuel niveau de prestation particulier, pris en compte, lui, dans la grille locative).
            </p>
          </div>
          <div class="titre-2">
            Hypoth&egrave;ses de prix de vente du programme
          </div>
          <div class="lex-content">
            <p>
              Les hypoth&egrave;ses de prix de vente du programme sont
              indiqu&eacute;es&nbsp;:
            </p>
            <ul>
              <li>
                En &euro;/m&sup2; hors stationnement et avec stationnement pour
                le collectif
              </li>
              <li>En prix unitaire pour le prix du stationnement</li>
              <li>
                En prix unitaire avec stationnement pour l&rsquo;individuel
              </li>
            </ul>
          </div>

          <div class="titre-1">
            Niveau de priorité
          </div>
          <div class="source">Source : ADEQUATION</div>

          <div class="titre-1">
            Localisation du projet
          </div>
          <div class="source">Source : ADEQUATION</div>
          <div class="lex-content">
            <p>
              <span class="title">Rythme de vente par mois :</span> il est calcul&eacute; hors queue de
                  programme, c&rsquo;est-&agrave;-dire sur la commercialisation
                  &agrave; 90% du programme.
            </p>
            <p>
              <b>Mise en vente</b> : Date de commercialisation du programme (mois année)
            </p>
          </div>

          <div class="titre-1">
           Dynamique territoriale
          </div>
          <div class="source bloc">
            Source : INSEE {{lexiqueParam.sociodemo_annee_max_demographie}}
          </div>
          <div class="lex-content">
             <p>
            Population, m&eacute;nages, emm&eacute;nagements, part de CSP+, taux de ch&ocirc;mage, part du logement social
            </p>
          </div>
        <div class="source bloc">
          Sources : INSEE FILOSOFI {{lexiqueParam.budget_annee}}
        </div>
        <div class="lex-content">
          <p>
            <span class="title">Revenu m&eacute;dian :</span> il est estim&eacute; par
            m&eacute;nage. L&rsquo;INSEE communique des revenus &agrave;
            l&rsquo;unit&eacute; de consommation (UC) ce qui correspond &agrave;
            une pond&eacute;ration des individus au sein des m&eacute;nages.
            Or, ce sont bien les m&eacute;nages qui ach&egrave;tent des logements.
            La donn&eacute;e est retravaill&eacute;e par ADEQUATION et les
            revenus d&rsquo;UC sont convertis en m&eacute;nage afin de
            conna&icirc;tre les vraies capacit&eacute;s d&rsquo;emprunt.
          </p>
        </div>
        <div class="source bloc">
          Source SITADEL {{lexiqueParam.sitadel_annee_max_sitadel}}
        </div>
        <div class="lex-content">
          <ul>
            <li>
              <span class="title">Nombre de constructions&nbsp;:</span> il s&rsquo;agit des logements
              ordinaires commenc&eacute;s (neuf et Acquisition-Am&eacute;lioration
              (AA)). La donn&eacute;e est moyenn&eacute;e sur les 3
              derni&egrave;res ann&eacute;es.
            </li>
            <li>
              <span class="title">Dynamisme de la construction globale&nbsp;:</span> il s&rsquo;agit d&rsquo;un ratio de production de
              logements (neuf et AA)) commenc&eacute;s pour 1.000 habitants
              couramment utilis&eacute; pour appr&eacute;cier l'activit&eacute; de
              la construction du logement (neuf + AA).
            </li>
          </ul>
        </div>

        <div class="titre-1">
          March&eacute; de la promotion immobili&egrave;re
        </div>
        <div class="source">Source : ADEQUATION &ndash; DVF</div>
        
        <div class="lex-content">
       <ul>
          <li>
             <span class="title">Mises en vente&nbsp;:</span> nombre de logements lanc&eacute;s &agrave; la
            commercialisation au cours de la p&eacute;riode.
          </li>
          <li>
             <span class="title">Ventes nettes:</span> total des r&eacute;servations, nettes de d&eacute;sistements.
          </li>
          <li>
            <span class="title">Offre&nbsp;:</span>
            nombre de logements disponibles &agrave; la vente en fin de
            p&eacute;riode, qu'ils soient sur plan, en chantier ou
            livr&eacute;s.<br />
          </li>
          <li>
            <span class="title">Prix&nbsp;:</span> indiqu&eacute; pour le logement collectif
            avec stationnement (avec stat.) ou hors stationnement (hors
            stat.)
          </li>
          </ul>
        </div>

        <div class="titre-1">
          Indicateurs clés
        </div>
        <div class="source">
           Le pourcentage correspond à l’évolution par rapport à la période n-1
        </div>
          

          <div class="titre-1">
            Situation du march&eacute; locatif
          </div>
          <div class="titre-2">Livraisons</div>
          <div class="source">
            Sources : Libre &ndash; ADEQUATION / LAC et LLI &ndash; CDC
                    Habitat / PLS &ndash; RPLS {{lexiqueParam.rpls_annee_max}}
          </div>
          <div class="lex-content">
            <p>
            <span class="title">Les livraisons :</span> nombre de logements livr&eacute;s ou qui seront
            livr&eacute;s chaque ann&eacute;e par segment.
            </p>
          </div>
          <div class="titre-2">Les loyers</div>
          <div class="source">Source : Clameur</div>
          <p>
            Les loyers Clameur comprennent les logements neufs et anciens
            r&eacute;nov&eacute;s. Le champ d&rsquo;observation est celui des
            baux nouveaux d&rsquo;habitation, hors donc toutes les indexations
            en cours de bail ou lors d&rsquo;un renouvellement de bail.
            L&rsquo;observatoire porte ainsi exclusivement sur les loyers de
            march&eacute; pour des baux conclus &agrave; l&rsquo;occasion
            d&rsquo;une relocation ou d&rsquo;une location nouvelle. Les loyers
            sont indiqu&eacute;s en &euro;/m&sup2;/mois et sont exprim&eacute;s
            hors charges (HC) et en surface habitable.
          </p>
          <p>
            Ann&eacute;e {{lexiqueParam.clameur_typologie_annee_max_ensemble}}
            pour la donn&eacute;e &agrave; la typologie.
          </p>
          <p>
            Ann&eacute;e {{lexiqueParam.clameur_annee_max_ensemble}} pour la donn&eacute;e globale. Le pourcentage d&rsquo;&eacute;volution de ce loyer se rapporte
            &agrave; l&rsquo;ann&eacute;e n-1.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import PageMixin from "@/components/study/editor/pages/page.mixin.js";

export default {
	name: "section-lexique1",
	mixins: [PageMixin],
	props: {
		main_color: { default: "gray" },
	},
	data: function () {
		return {
		};
	},
	computed: {
		...mapGetters(["active_study"]),
		lexiqueParam (){
			return this.active_study.qlikData.parameters.lexiqueParam;
		}
	},
	components: {}
};
</script>

<style lang="stylus" scoped>
@import '../../../../../assets/css/app';
@import '../../../../../assets/css/page';
@import '../../../../../assets/css/lexique';
</style>
